import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {withFormik} from "formik";

import Divider from "../../utilities/Divider/Divider";
import usePagination from "../../utilities/hooks/usePagination";
import {Filters, SessionFiltersContainer} from "../conteiners/filters/Filter.hoc";
import {DateInput, TextInput} from "../Inputs";
import {Select} from "../Inputs/SelectField";
import {DEV_TICKETS_LIST_WINDOW_NAME} from "../Reference/DevTicketsList/DevTicketsList";

import DevITBody from "./DevITBody";
import {fetchAllTickets, fetchAllTicketTypes, fetchDevITFilters, selectDevITFilters} from "./DevITSlice";

const DevIT = () => {
  const dispatch = useDispatch();
  const {
    i18n: {language},
  } = useTranslation();

  const {setPage, changePage, onPaginate, page} = usePagination();

  const fetchedFilters = useSelector(selectDevITFilters);
  const filters = JSON.parse(sessionStorage.getItem(DEV_TICKETS_LIST_WINDOW_NAME));

  const typesFiltersOptions =
    fetchedFilters?.types?.map(({typeId, nameEng, nameUkr}) => ({
      value: typeId,
      title: language === "en" ? nameEng : nameUkr,
    })) ?? [];
  const statusFiltersOptions =
    fetchedFilters?.statuses?.map(({statusId, nameEng, nameUkr}) => ({
      value: statusId,
      title: language === "en" ? nameEng : nameUkr,
    })) ?? [];

  const onPageReset = () => setPage({currentPage: 1, totalPages: 1});

  useEffect(() => {
    onPageReset();
  }, [JSON.stringify(filters)]);

  useEffect(() => {
    dispatch(fetchAllTicketTypes());
  }, []);

  useEffect(() => {
    dispatch(fetchDevITFilters(filters));
  }, [JSON.stringify(filters)]);

  useEffect(() => {
    const params = {page: page?.currentPage, ...filters};
    dispatch(fetchAllTickets(params))
      .unwrap()
      .then(changePage)
      .catch(err => console.error(err));
  }, [page?.currentPage, JSON.stringify(filters)]);

  return (
    <div className="fcCol pt5 h100 fGrow maxH100">
      <SessionFiltersContainer window={DEV_TICKETS_LIST_WINDOW_NAME} onFilterChange={onPageReset}>
        <Filters>
          <div className="row w100 gap h100 aic">
            <Select label="Appeal type" options={typesFiltersOptions} name="typeId" />
            <Select label="Status" options={statusFiltersOptions} name="statusId" />

            <TextInput label="Appeal text" name="text" generalClassName="fGrow" autolabel />
            <DateInput label="Period From" name="dateFrom" />
            <DateInput label="To" name="dateTo" />
          </div>
        </Filters>
        <Divider margin="3px" />
        <DevITBody onPaginate={onPaginate} page={page} />
      </SessionFiltersContainer>
    </div>
  );
};

export default withFormik({enableReinitialize: true})(DevIT);
